export const TOKEN = 'token';
// token 时间戳
export const TIME_STAMP = 'timeStamp';
// 超时时长(毫秒) 14天
export const TOKEN_TIMEOUT_VALUE = 14 * 24 * 3600 * 1000;
// tags
export const TAGS_VIEW = 'tagsView';
// baseUrl
// export const BASEURL = '//192.168.2.131:8080'
export const BASEURL =
  process.env.NODE_ENV === 'development'
    ? 'https://live.wxls.pro'
    : 'https://live.wxls.pro';

// basicUrl
export const BASICURL = 'https://api.wxls.pro';
